var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationHeader',{attrs:{"title":"Trucs et outils en milieu de travail"}})}
var staticRenderFns = []

export { render, staticRenderFns }